<script lang="ts">
    import type { Creative } from '../../modules/brokerApi/creatives/creative'
    import type { Channel } from '../../modules/brokerApi/channels/channel'
    import { TagsRepository } from '../../modules/eventsApi/tags/tags.repository'
    import { TagsService } from '../../modules/eventsApi/tags/tags.service'
    import type { Board } from '../../modules/pipelineApi/pipeline/boards/board'
    import { BoardsRepository } from '../../modules/pipelineApi/pipeline/boards/boards.repository'
    import { BoardsService } from '../../modules/pipelineApi/pipeline/boards/boards.service'
    import type { List } from '../../modules/pipelineApi/pipeline/lists/list'
    import { ListsRepository } from '../../modules/pipelineApi/pipeline/lists/lists.repository'
    import { ListsService } from '../../modules/pipelineApi/pipeline/lists/lists.service'
    import type { User } from '../../modules/usersApi/users/user'
    import { CompaniesRepository } from '../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../modules/usersApi/companies/companies.service'
    import { Automation } from '../../modules/automationApi/automations/automation'
    import { AutomationsRepository } from '../../modules/automationApi/automations/automation.repository'
    import { AutomationsService } from '../../modules/automationApi/automations/automation.service'
    import type { CreateAutomationDto as CreateEntityDto } from '../../modules/automationApi/automations/dto/create-automation.dto'
    import type { UpdateAutomationDto as UpdateEntityDto } from '../../modules/automationApi/automations/dto/update-automation.dto'
    import { onMount } from 'svelte'
    import LoginFacebook from '../_common/login-facebook.svelte'
    import { FacebookRepository } from '../../modules/automationApi/facebook/facebook.repository'
    import { FacebookService } from '../../modules/automationApi/facebook/facebook.service'
    import { AutomationSourceEnum } from '../../modules/automationApi/automations/automation-source.enum'
    import type { TagEntity } from '../../modules/eventsApi/tags/tag.entity'
    import AutomManActsMessage from './autom-man-acts-message.svelte'

    export let automationGroupId: string
    export let automationId: string = null
    export let source = ''

    let automation: Automation = new Automation()
    let delay: number = 0
    let delayFactor: number = 1000

    const rep = new AutomationsRepository(automationGroupId)
    const service = new AutomationsService(rep)

    let loaded = false
    onMount(async () => {
        await loadCreatives()
        await loadAllChannels()
        loadActs()
        await updateParentRuleLabel()
        loaded = true
    })

    $: {
        onAutomationIdChange(automationId)
    }

    async function onAutomationIdChange(id) {
        if (id) {
            await editEntity(automationId)
        } else {
            automation = new Automation()
        }
    }

    let acts = []
    function loadActs() {
        clearActs()
        //console.log(' = source = ', source, automation)
        if (source === AutomationSourceEnum.automacao_comunicacao) {
            acts = [
                { label: 'enviar mensagem', value: 'automacao_comunicacao_enviar_mensagem' },
                //{ label: 'enviar para o Facebook Ads', value: 'automacao_comunicacao_facebook' },
            ]
            if (window.beta) {
                acts.push({ label: 'enviar para o Facebook Ads', value: 'automacao_comunicacao_facebook' })
            }
        } else if (source === AutomationSourceEnum.automacao_pipeline) {
            acts = [
                { label: 'criar cartão no pipeline', value: 'automacao_pipeline_novo' },
                // { label: 'mover cartão no pipeline', value: 'automacao_pipeline_mover' },
                // { label: 'alterar status do cartão no pipeline', value: 'automacao_pipeline_status' },
            ]
        } else if (source === AutomationSourceEnum.automacao_nps) {
            acts = [{ label: 'pedir avaliação NPS', value: 'automacao_nps_solicitar' }]
        } else if (source === AutomationSourceEnum.automacao_indica) {
            acts = [{ label: 'contactar um indicado', value: 'automacao_indica_contactar' }]
        } else if (source === AutomationSourceEnum.automacao_agenda || source === AutomationSourceEnum.automacao_agenda_2) {
            acts = [{ label: 'solicitar confirmação da agenda', value: 'automacao_agenda_confirmar' }]
        } else if (source === AutomationSourceEnum.automacao_pdv) {
            acts = [{ label: 'enviar mensagem pós-compra', value: 'automacao_pdv_comprou' }]
        } else {
            acts = [{ label: 'Selecione...', value: '' }]
        }
    }

    let loading = false
    function clearActs() {
        if (loading) return
        automation.tagId = ''
        automation.boardId = ''
        automation.listId = ''
        automation.userId = ''
    }

    let creatives: Creative[] = []
    async function loadCreatives() {
        creatives = await window.api.brokers.creatives.getAll()
    }

    let channels: Channel[] = []
    async function loadAllChannels() {
        channels = await window.api.brokers.channels.getAll({ updateStatus: false })
    }

    let tags: TagEntity[] = []
    async function loadTags() {
        const tagsR = new TagsRepository()
        const tagsS = new TagsService(tagsR)
        tags = await tagsS.getAll()
    }

    let boards: Board[] = []
    async function loadBoards() {
        const boardsR = new BoardsRepository()
        const boardsS = new BoardsService(boardsR)
        boards = await boardsS.getAll()
    }

    let lists: List[] = []
    async function loadLists(boardId: string) {
        if (!loading) automation.listId = ''
        const listsR = new ListsRepository('boards/' + boardId + '/lists')
        const listsS = new ListsService(listsR)
        lists = await listsS.getAll()
    }

    let users: User[] = []
    async function loadUsers() {
        const compR = new CompaniesRepository()
        const compS = new CompaniesService(compR)
        users = await compS.getCompanyUsers()
        console.log('users', users)
    }

    let show = false

    async function createEntity() {
        try {
            show = true
            const dto: CreateEntityDto = {
                automationGroupId,
                act: automation.act,
                boardId: automation.boardId,
                userId: automation.userId,
                boardStatus: automation.boardStatus,
                channelId: automation.channelId,
                creativeId: automation.creativeId,
                listId: automation.listId,
                message: automation.message,
                tagId: automation.tagId,
                delay: delay * delayFactor,
                fbAdsAccount: automation.fbAdsAccount,
                fbId: automation.fbId,
                fbToken: automation.fbToken,
                expirationInHours: automation.expirationInHours,
            }
            if (!validateDto(dto)) return false
            automation = await service.create(dto)
            console.log('automation', automation)
            return true
        } catch (error) {
            evaluateError(error)
            return false
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdateEntityDto = {
                automationGroupId,
                act: automation.act,
                boardId: automation.boardId,
                userId: automation.userId,
                boardStatus: automation.boardStatus,
                channelId: automation.channelId,
                creativeId: automation.creativeId,
                listId: automation.listId,
                message: automation.message,
                tagId: automation.tagId,
                delay: delay * delayFactor,
                fbAdsAccount: automation.fbAdsAccount,
                fbId: automation.fbId,
                fbToken: automation.fbToken,
                expirationInHours: automation.expirationInHours,
            }
            if (!validateDto(dto)) return false
            const result = await service.update(automation.automationId, dto)
            console.log('automation', result)
            return true
        } catch (error) {
            evaluateError(error)
            return false
        } finally {
            show = false
        }
    }

    export async function saveEntity() {
        //if (childAct.saveEntity(automation.parentAutomationId)) {
        if (automation.automationId) {
            return await updateEntity()
        } else {
            return await createEntity()
        }
        //}
    }

    let parentRuleLabel: string = ''
    async function updateParentRuleLabel() {
        if (!automation?.parentRule) {
            parentRuleLabel = 'Ao entrar no público...'
        }
    }

    async function editEntity(id: string) {
        loading = true
        try {
            show = true
            automation = new Automation()
            automation = await service.getOne(id, { rules: true })
            let { factor } = getDynamicDateFactor(automation.delay, automation.delay)
            delayFactor = factor
            delay = automation.delay / delayFactor
            await updateParentRuleLabel()
            if (automation.tagId) {
                await loadTags()
                automation.tagId = automation.tagId
            }
            if (automation.act.includes('automacao_pipeline_')) {
                await loadUsers()
                await loadBoards()
                automation.boardId = automation.boardId
                await loadLists(automation.boardId)
                automation.listId = automation.listId
            }
            if (automation.act.includes('automacao_comunicacao_facebook')) {
                if (automation.fbToken) {
                    await loadAdsAccounts()
                }
            }
        } catch (error) {
            evaluateError(error)
        } finally {
            loading = false
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function validateDto(dto) {
        if (dto.act === 'automacao_comunicacao_facebook') {
            if (!dto.fbAdsAccount) {
                evaluateError('Informe a conta de anúncios do Facebook')
                return false
            }
        }
        if (
            dto.act === 'automacao_comunicacao_enviar' ||
            dto.act === 'automacao_comunicacao_enviar_mensagem' ||
            dto.act === 'automacao_nps_solicitar' ||
            dto.act === 'automacao_agenda_confirmar' ||
            dto.act === 'automacao_pdv_comprou' ||
            dto.act === 'automacao_indica_contactar'
        ) {
            if (!dto.channelId) {
                evaluateError('Selecione a conexão a ser utilizada para o envio')
                return false
            }
        }

        return true
    }

    $: globalAct = automation?.act
    $: globalBoardId = automation?.boardId

    $: if (source) loadActs()
    $: if (globalAct) clearActs()

    $: {
        if (globalAct === 'automacao_classificacao_classificar') {
            loadTags()
        }
    }

    $: {
        if (globalAct?.includes('automacao_pipeline_')) {
            loadUsers()
            loadBoards()
        }
    }

    $: {
        if (globalAct?.includes('automacao_pipeline_') && globalBoardId) {
            loadLists(globalBoardId)
        }
    }

    let currentCreativeService = ''
    $: {
        const service = creatives.find((el) => el.creativeId === automation.creativeId)?.service
        switch (service) {
            case 'call':
                currentCreativeService = 'Torpedo de Voz'
                break
            case 'sms':
                currentCreativeService = 'SMS'
                break
            case 'email':
                currentCreativeService = 'E-Mail'
                break
            case 'wa':
                currentCreativeService = 'WhatsApp'
                break

            default:
                currentCreativeService = ''
                break
        }
    }

    const factors = [1000, 3600000, 86400000, 2592000000, 31536000000]
    const factorsLabel = ['minuto(s)', 'hora(s)', 'dia(s)', 'mes(es)', 'ano(s)']
    const factor_minute = 0
    const factor_hour = 1
    const factor_day = 2
    const factor_month = 3
    const factor_year = 4
    const maxRepeat = 60
    function getDynamicDateFactor(dateFrom: number, dateTo: number) {
        const dateRef = Math.abs(dateFrom) > Math.abs(dateTo) ? dateFrom : dateTo
        const past = dateRef < 0 ? -1 : 1
        // hora, dia, mes, ano
        let pos = 0
        let factor = 0
        for (let index = 0; index < factors.length; index++) {
            const base = dateRef / maxRepeat
            pos = index
            factor = factors[index]
            if (base <= factors[index]) break
        }
        factor *= past
        let label = factorsLabel[pos]
        return { factor, label }
    }

    let fbAccounts: { name: string; id: string }[] = []
    async function onFacebookSuccess(ev) {
        automation.fbId = ev.detail.userId
        automation.fbToken = ev.detail.accessToken
        await loadAdsAccounts()
    }

    async function loadAdsAccounts() {
        const fbR = new FacebookRepository()
        const fbS = new FacebookService(fbR)
        fbAccounts = (await fbS.getAdsAccounts(automation.fbId, automation.fbToken)) || []
        console.log('loadAdsAcc', automation.fbId, automation.fbToken, fbAccounts)
        automation.fbAdsAccount = automation.fbAdsAccount
    }

    function onFacebookInfo(ev) {
        console.log('ev-fb-info', ev)
    }
</script>

{#if automation && loaded}
    <div class="sizer green">
        <div class="line"><div>{parentRuleLabel}</div></div>
        <div class="config-box">
            <div class="row">
                <div class="col col-md-12">
                    <div class="input-group">
                        <!-- <label for="" class="input-group-text">Aguardar</label>
                        <select class="form-select limit-width" name="delay" bind:value={delay} id="delay">
                            {#each Array(maxRepeat) as _, i}
                                <option value={i}>{i}</option>
                            {/each}
                        </select>
                        <select class="form-select limit-width" name="dinamicoFator" bind:value={delayFactor} id="dinamicoFator">
                            <option value={factors[factor_minute]}>minuto(s)</option>
                            <option value={factors[factor_hour]}>hora(s)</option>
                            <option value={factors[factor_day]}>dia(s)</option>
                            <option value={factors[factor_month]}>mes(es)</option>
                            <option value={factors[factor_year]}>ano(s)</option>
                        </select> -->
                        <label for="" class="input-group-text">Ação</label>
                        <select class="form-select" bind:value={automation.act} name="" id="">
                            {#each acts as act}
                                <option value={act.value}>{act.label}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                {#if automation?.act === 'automacao_comunicacao_facebook'}
                    {#if fbAccounts?.length === 0}
                        <div class="login-fb">
                            <div class="-help">Para enviar este público primeiro faça login</div>
                            <div>
                                <LoginFacebook
                                    small={true}
                                    appId="3285321171787338"
                                    configId="406974741864078"
                                    on:auth-success={onFacebookSuccess}
                                    on:auth-info={onFacebookSuccess}
                                />
                            </div>
                        </div>
                    {:else}
                        <div class="input-group">
                            <label for="" class="input-group-text">Selecione a conta de anúncios</label>
                            <select class="form-select" name="" id="" bind:value={automation.fbAdsAccount}>
                                <option value="">Selecione...</option>
                                {#each fbAccounts as account}
                                    <option value={account.id}>{account.name}</option>
                                {/each}
                            </select>
                        </div>
                    {/if}
                {/if}

                {#if automation?.act?.startsWith('automacao_comunicacao_enviar')}
                    <div class="my-2">
                        <AutomManActsMessage
                            act={automation.act}
                            {channels}
                            {creatives}
                            bind:message={automation.message}
                            bind:channelId={automation.channelId}
                            bind:creativeId={automation.creativeId}
                            isEdit={!!automation.automationId}
                        ></AutomManActsMessage>
                    </div>
                    {#if !automation.creativeId}
                        <div class="col col-md-12">
                            <div class="text-muted">
                                Chaves disponíveis:
                                <span class="code">&#123;nome&#125;</span>
                                <span class="code">&#123;primeironome&#125;</span>
                                <span class="code">&#123;agendaonline&#125;</span>
                            </div>
                        </div>
                    {/if}
                    <div class="col col-md-8">
                        <div class="input-group">
                            <label for="" class="input-group-text">Descartar mensagem se não entregue em até</label>
                            <select class="form-select" name="" id="" bind:value={automation.expirationInHours}>
                                {#if source.startsWith('automacao_agenda')}
                                    <option value={0}>data do agendamento</option>
                                {:else}
                                    <option value={0}>[nunca descartar]</option>
                                {/if}
                                <option value={1 * 12}>12 horas</option>
                                <option value={1 * 24}>1 dia</option>
                                <option value={2 * 24}>2 dias</option>
                                <option value={3 * 24}>3 dias</option>
                                <option value={5 * 24}>5 dias</option>
                                <option value={7 * 24}>7 dias</option>
                                <option value={10 * 24}>10 dias</option>
                                <option value={14 * 24}>14 dias</option>
                                <option value={30 * 24}>30 dias</option>
                            </select>
                        </div>
                    </div>
                {/if}
                {#if automation?.act === 'automacao_nps_solicitar'}
                    <div class="my-2">
                        <AutomManActsMessage
                            act={automation.act}
                            {channels}
                            {creatives}
                            bind:message={automation.message}
                            bind:channelId={automation.channelId}
                            bind:creativeId={automation.creativeId}
                            isEdit={!!automation.automationId}
                        ></AutomManActsMessage>
                    </div>
                    {#if !automation.creativeId}
                        <div class="col col-md-12">
                            <div class="text-muted">
                                Inclua a chave <span class="code">&#123;npslink&#125;</span> no local da mensagem onde desejar inserir o link de avaliação.
                                <br />Outras chaves também estão disponíveis:
                                <span class="code">&#123;nome&#125;</span>
                                <span class="code">&#123;primeironome&#125;</span>;
                                <span class="code">&#123;agendaonline&#125;</span>
                            </div>
                        </div>
                    {/if}
                    <div class="col col-md-8">
                        <div class="input-group">
                            <label for="" class="input-group-text">Descartar mensagem se não entregue em até</label>
                            <select class="form-select" name="" id="" bind:value={automation.expirationInHours}>
                                {#if source.startsWith('automacao_agenda')}
                                    <option value={0}>data do agendamento</option>
                                {:else}
                                    <option value={0}>[nunca descartar]</option>
                                {/if}
                                <option value={1 * 12}>12 horas</option>
                                <option value={1 * 24}>1 dia</option>
                                <option value={2 * 24}>2 dias</option>
                                <option value={3 * 24}>3 dias</option>
                                <option value={5 * 24}>5 dias</option>
                                <option value={7 * 24}>7 dias</option>
                                <option value={10 * 24}>10 dias</option>
                                <option value={14 * 24}>14 dias</option>
                                <option value={30 * 24}>30 dias</option>
                            </select>
                        </div>
                    </div>
                {/if}

                {#if automation?.act?.substring(0, 19) === 'automacao_pipeline_'}
                    {#if automation.act === 'automacao_pipeline_novo'}
                        <div class="col col-md-6">
                            <div class="input-group">
                                <label for="" class="input-group-text">Selecione o usuário</label>
                                <select class="form-select" name="" id="" bind:value={automation.userId}>
                                    <option value="">Selecione...</option>
                                    {#each users as user}
                                        <option value={user.userId}>{user.userName + ' / ' + user.email}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    {/if}
                    <div class="col col-md-6">
                        <div class="input-group">
                            <label for="" class="input-group-text">Selecione o pipeline</label>
                            <select class="form-select" name="" id="" bind:value={automation.boardId}>
                                <option value="">Selecione...</option>
                                {#if automation.act === 'automacao_pipeline_status'}
                                    <option value="*">Todos</option>
                                {/if}
                                {#each boards as board}
                                    <option value={board.boardId}>{board.label}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                    {#if lists.length > 0}
                        <div class="col col-md-6">
                            <div class="input-group">
                                <label for="" class="input-group-text">Selecione a lista</label>
                                <select class="form-select" name="" id="" bind:value={automation.listId}>
                                    <option value="">Selecione...</option>
                                    {#if automation.act === 'automacao_pipeline_status'}
                                        <option value="*">Todas</option>
                                    {/if}
                                    {#each lists as list}
                                        <option value={list.listId}>{list.label}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    {/if}
                {/if}
                {#if automation?.act === 'automacao_agenda_confirmar'}
                    <div class="my-2">
                        <AutomManActsMessage
                            act={automation.act}
                            {channels}
                            {creatives}
                            bind:message={automation.message}
                            bind:channelId={automation.channelId}
                            bind:creativeId={automation.creativeId}
                            isEdit={!!automation.automationId}
                        ></AutomManActsMessage>
                    </div>
                    {#if !automation.creativeId}
                        <div class="col col-md-12">
                            <div class="text-muted">
                                Inclua a chave <span class="code">&#123;agendalink&#125;</span> no local da mensagem onde desejar inserir o link de confirmação.
                                <br />Outras chaves também estão disponíveis:
                                <span class="code">&#123;nome&#125;</span>
                                <span class="code">&#123;primeironome&#125;</span>
                                <span class="code">&#123;dataevento&#125;</span>
                                <span class="code">&#123;horaevento&#125;</span>;
                                <span class="code">&#123;agendaonline&#125;</span>
                            </div>
                        </div>
                    {/if}
                    <div class="col col-md-12">
                        <div class="input-group">
                            <label for="" class="input-group-text">Descartar mensagem se não entregue em até</label>
                            <select class="form-select" name="" id="" bind:value={automation.expirationInHours}>
                                {#if source.startsWith('automacao_agenda')}
                                    <option value={0}>data do agendamento</option>
                                {:else}
                                    <option value={0}>[nunca descartar]</option>
                                {/if}
                                <option value={1 * 12}>12 horas</option>
                                <option value={1 * 24}>1 dia</option>
                                <option value={2 * 24}>2 dias</option>
                                <option value={3 * 24}>3 dias</option>
                                <option value={5 * 24}>5 dias</option>
                                <option value={7 * 24}>7 dias</option>
                                <option value={10 * 24}>10 dias</option>
                                <option value={14 * 24}>14 dias</option>
                                <option value={30 * 24}>30 dias</option>
                            </select>
                        </div>
                    </div>
                {/if}
                {#if automation?.act === 'automacao_pdv_comprou'}
                    <div class="my-2">
                        <AutomManActsMessage
                            act={automation.act}
                            {channels}
                            {creatives}
                            bind:message={automation.message}
                            bind:channelId={automation.channelId}
                            bind:creativeId={automation.creativeId}
                            isEdit={!!automation.automationId}
                        ></AutomManActsMessage>
                    </div>
                    {#if !automation.creativeId}
                        <div class="col col-md-12">
                            <div class="text-muted">
                                Chaves de personalização disponíveis:
                                <span class="code">&#123;nome&#125;</span>
                                <span class="code">&#123;primeironome&#125;</span>
                                <span class="code">&#123;agendaonline&#125;</span>
                            </div>
                        </div>
                    {/if}
                    <div class="col col-md-8">
                        <div class="input-group">
                            <label for="" class="input-group-text">Descartar mensagem se não entregue em até</label>
                            <select class="form-select" name="" id="" bind:value={automation.expirationInHours}>
                                {#if source.startsWith('automacao_agenda')}
                                    <option value={0}>data do agendamento</option>
                                {:else}
                                    <option value={0}>[nunca descartar]</option>
                                {/if}
                                <option value={1 * 12}>12 horas</option>
                                <option value={1 * 24}>1 dia</option>
                                <option value={2 * 24}>2 dias</option>
                                <option value={3 * 24}>3 dias</option>
                                <option value={5 * 24}>5 dias</option>
                                <option value={7 * 24}>7 dias</option>
                                <option value={10 * 24}>10 dias</option>
                                <option value={14 * 24}>14 dias</option>
                                <option value={30 * 24}>30 dias</option>
                            </select>
                        </div>
                    </div>
                {/if}
                {#if automation?.act === 'automacao_indica_contactar'}
                    <div class="my-2">
                        <AutomManActsMessage
                            act={automation.act}
                            {channels}
                            {creatives}
                            bind:message={automation.message}
                            bind:channelId={automation.channelId}
                            bind:creativeId={automation.creativeId}
                            isEdit={!!automation.automationId}
                        ></AutomManActsMessage>
                    </div>
                    {#if !automation.creativeId}
                        <div class="col col-md-12">
                            <div class="text-muted">
                                <br />Chaves de personalização disponíveis:
                                <span class="code">&#123;nome&#125;</span>
                                <span class="code">&#123;primeironome&#125;</span>
                                <span class="code">&#123;indicadorprimeironome&#125;</span>
                                <span class="code">&#123;agendaonline&#125;</span>
                            </div>
                        </div>
                    {/if}
                    <div class="col col-md-8">
                        <div class="input-group">
                            <label for="" class="input-group-text">Descartar mensagem se não entregue em até</label>
                            <select class="form-select" name="" id="" bind:value={automation.expirationInHours}>
                                {#if source.startsWith('automacao_agenda')}
                                    <option value={0}>data do agendamento</option>
                                {:else}
                                    <option value={0}>[nunca descartar]</option>
                                {/if}
                                <option value={1 * 12}>12 horas</option>
                                <option value={1 * 24}>1 dia</option>
                                <option value={2 * 24}>2 dias</option>
                                <option value={3 * 24}>3 dias</option>
                                <option value={5 * 24}>5 dias</option>
                                <option value={7 * 24}>7 dias</option>
                                <option value={10 * 24}>10 dias</option>
                                <option value={14 * 24}>14 dias</option>
                                <option value={30 * 24}>30 dias</option>
                            </select>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    .sizer {
        max-width: 60%;
    }
    .config-box .row .col {
        margin-top: 4px;
        margin-bottom: 4px;
    }
    .config-box {
        position: relative;
    }
    .line {
        border-left: 2px solid #328866;
        margin-left: 24px;
    }
    .line > div {
        background-color: #328866;
        margin: 10px 0px;
        color: #ddd;
        display: inline-block;
        font-size: 13px;
        padding: 0px 6px 0px 3px;
        border-radius: 0px 4px 4px 0px;
    }

    .green .line {
        border-left-color: #328866;
    }
    .green .line > div {
        background-color: #328866;
    }
    .green .config-box {
        border-color: #328866;
    }
    .limit-width {
        max-width: 140px;
    }

    .login-fb > * {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
    }
</style>
